<div class="mb-2 flex items-center justify-between">
  <h1 class="main-title">Gestión de turnos > Novedades Diarias Jefe de Turno > Previsualización</h1>
  <a class="button button-outlined-primary button-sm" [routerLink]="['/daily-shift']">
    <i class="fa-solid fa-chevron-left" alt=""></i>
    Volver
  </a>
</div>
<div class="single-page-content">
  <h2 class="main-subtitle">Seguridad / Medio Ambiente / Calidad</h2>
  <app-table
    class="table-news table-switch"
    [columns]="seguridadColumns"
    [data]="flattenedData.seguridad"
  >
    <ng-template #actionTemplate let-row>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(row)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="Ver" />
        </button>
        <button (click)="openCloneConfirmation(row)" title="Clonar">
          <img src="assets/icons/copy-icon.svg" alt="Clonar" />
        </button>
        <button (click)="editUpdateRecord(row)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="Editar" />
        </button>
        <button (click)="deleteUpdateRecord(row.id)" title="Eliminar">
          <img src="assets/icons/trashcan-icon.svg" alt="Eliminar" />
        </button>
      </div>
    </ng-template>
  </app-table>

  <h2 class="main-subtitle">Personal (Ausentismo, Licencias Médicas)</h2>
  <app-table
    class="table-news table-switch"
    [columns]="personalColumns"
    [data]="flattenedData.personal"
  >
    <ng-template #actionTemplate let-row>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(row)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="Ver" />
        </button>
        <button (click)="openCloneConfirmation(row)" title="Clonar">
          <img src="assets/icons/copy-icon.svg" alt="Clonar" />
        </button>
        <button (click)="editUpdateRecord(row)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="Editar" />
        </button>
        <button (click)="deleteUpdateRecord(row.id)" title="Eliminar">
          <img src="assets/icons/trashcan-icon.svg" alt="Eliminar" />
        </button>
      </div>
    </ng-template>
  </app-table>

  <h2 class="main-subtitle text-primary">Novedades por Área</h2>

  <h2>DCS</h2>
  <app-table class="table-news table-switch" [columns]="areaColumns" [data]="flattenedData.dcs">
    <ng-template #actionTemplate let-row>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(row)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="Ver" />
        </button>
        <button (click)="openCloneConfirmation(row)" title="Clonar">
          <img src="assets/icons/copy-icon.svg" alt="Clonar" />
        </button>
        <button (click)="editUpdateRecord(row)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="Editar" />
        </button>
        <button (click)="deleteUpdateRecord(row.id)" title="Eliminar">
          <img src="assets/icons/trashcan-icon.svg" alt="Eliminar" />
        </button>
      </div>
    </ng-template>
  </app-table>

  <h2>Salmuera Primaria</h2>
  <app-table
    class="table-news table-switch"
    [columns]="areaColumns"
    [data]="flattenedData.salmuera_i"
  >
    <ng-template #actionTemplate let-row>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(row)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="Ver" />
        </button>
        <button (click)="openCloneConfirmation(row)" title="Clonar">
          <img src="assets/icons/copy-icon.svg" alt="Clonar" />
        </button>
        <button (click)="editUpdateRecord(row)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="Editar" />
        </button>
        <button (click)="deleteUpdateRecord(row.id)" title="Eliminar">
          <img src="assets/icons/trashcan-icon.svg" alt="Eliminar" />
        </button>
      </div>
    </ng-template>
  </app-table>

  <h2>Salmuera Secundaria</h2>
  <app-table
    class="table-news table-switch"
    [columns]="areaColumns"
    [data]="flattenedData.salmuera_ii"
  >
    <ng-template #actionTemplate let-row>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(row)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="Ver" />
        </button>
        <button (click)="openCloneConfirmation(row)" title="Clonar">
          <img src="assets/icons/copy-icon.svg" alt="Clonar" />
        </button>
        <button (click)="editUpdateRecord(row)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="Editar" />
        </button>
        <button (click)="deleteUpdateRecord(row.id)" title="Eliminar">
          <img src="assets/icons/trashcan-icon.svg" alt="Eliminar" />
        </button>
      </div>
    </ng-template>
  </app-table>

  <h2>Electrolizadores</h2>
  <app-table
    class="table-news table-switch"
    [columns]="areaColumns"
    [data]="flattenedData.electrolizadores"
  >
    <ng-template #actionTemplate let-row>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(row)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="Ver" />
        </button>
        <button (click)="openCloneConfirmation(row)" title="Clonar">
          <img src="assets/icons/copy-icon.svg" alt="Clonar" />
        </button>
        <button (click)="editUpdateRecord(row)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="Editar" />
        </button>
        <button (click)="deleteUpdateRecord(row.id)" title="Eliminar">
          <img src="assets/icons/trashcan-icon.svg" alt="Eliminar" />
        </button>
      </div>
    </ng-template>
  </app-table>

  <h2>Subestación</h2>
  <app-table
    class="table-news table-switch"
    [columns]="areaColumns"
    [data]="flattenedData.subestacion"
  >
    <ng-template #actionTemplate let-row>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(row)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="Ver" />
        </button>
        <button (click)="openCloneConfirmation(row)" title="Clonar">
          <img src="assets/icons/copy-icon.svg" alt="Clonar" />
        </button>
        <button (click)="editUpdateRecord(row)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="Editar" />
        </button>
        <button (click)="deleteUpdateRecord(row.id)" title="Eliminar">
          <img src="assets/icons/trashcan-icon.svg" alt="Eliminar" />
        </button>
      </div>
    </ng-template>
  </app-table>

  <h2>Compresión</h2>
  <app-table
    class="table-news table-switch"
    [columns]="areaColumns"
    [data]="flattenedData.compresion"
  >
    <ng-template #actionTemplate let-row>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(row)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="Ver" />
        </button>
        <button (click)="openCloneConfirmation(row)" title="Clonar">
          <img src="assets/icons/copy-icon.svg" alt="Clonar" />
        </button>
        <button (click)="editUpdateRecord(row)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="Editar" />
        </button>
        <button (click)="deleteUpdateRecord(row.id)" title="Eliminar">
          <img src="assets/icons/trashcan-icon.svg" alt="Eliminar" />
        </button>
      </div>
    </ng-template>
  </app-table>

  <h2>Cloruro Férrico</h2>
  <app-table
    class="table-news table-switch"
    [columns]="areaColumns"
    [data]="flattenedData.cloruro_ferrico"
  >
    <ng-template #actionTemplate let-row>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(row)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="Ver" />
        </button>
        <button (click)="openCloneConfirmation(row)" title="Clonar">
          <img src="assets/icons/copy-icon.svg" alt="Clonar" />
        </button>
        <button (click)="editUpdateRecord(row)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="Editar" />
        </button>
        <button (click)="deleteUpdateRecord(row.id)" title="Eliminar">
          <img src="assets/icons/trashcan-icon.svg" alt="Eliminar" />
        </button>
      </div>
    </ng-template>
  </app-table>

  <h2>Movimiento de Productos</h2>
  <app-table
    class="table-news table-switch"
    [columns]="areaColumns"
    [data]="flattenedData.movimiento_producto"
  >
    <ng-template #actionTemplate let-row>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(row)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="Ver" />
        </button>
        <button (click)="openCloneConfirmation(row)" title="Clonar">
          <img src="assets/icons/copy-icon.svg" alt="Clonar" />
        </button>
        <button (click)="editUpdateRecord(row)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="Editar" />
        </button>
        <button (click)="deleteUpdateRecord(row.id)" title="Eliminar">
          <img src="assets/icons/trashcan-icon.svg" alt="Eliminar" />
        </button>
      </div>
    </ng-template>
  </app-table>

  <h2>Aviso de Avería</h2>
  <app-table
    class="table-news table-switch"
    [columns]="avisoAveriaColumns"
    [data]="flattenedData.avisoAveria"
  >
    <ng-template #actionTemplate let-row>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(row)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="Ver" />
        </button>
        <button (click)="openCloneConfirmation(row)" title="Clonar">
          <img src="assets/icons/copy-icon.svg" alt="Clonar" />
        </button>
        <button (click)="editUpdateRecord(row)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="Editar" />
        </button>
        <button (click)="deleteUpdateRecord(row.id)" title="Eliminar">
          <img src="assets/icons/trashcan-icon.svg" alt="Eliminar" />
        </button>
      </div>
    </ng-template>
  </app-table>
</div>

<app-confirm-popup
  *ngIf="showClonePopup"
  [message]="'¿Está seguro que deseas copiar esta novedad?'"
  (onConfirm)="confirmClone()"
  (onCancel)="closeClonePopup()"
></app-confirm-popup>
